import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IValuationEstimateClient,
} from 'interfaceAdapter/gatewaySchemas/IValuationEstimateClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/public/valuation_estimate`;

export class ValuationEstimateClient implements IValuationEstimateClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const {
            revenue_mjpy,
            operating_income_mjpy,
            depreciation_mjpy,
            cash_and_deposits_mjpy,
            interest_bearing_debt_mjpy,
            net_assets_mjpy,
            has_intellectual_property,
            ip_right_holder_type,
        } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({
            revenue_mjpy,
            operating_income_mjpy,
            depreciation_mjpy,
            cash_and_deposits_mjpy,
            interest_bearing_debt_mjpy,
            net_assets_mjpy,
            has_intellectual_property,
            ip_right_holder_type,
        });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
